(function () {
  'use strict';
  function initialize(scope) {
    scope.querySelectorAll('[data-ss-native-mobile-review]').forEach(function (panel) {
      if (panel.dataset.ssMobileReady === 'true') return;
      var productId = panel.dataset.productId;
      var nativeRoot = panel.closest('[data-ss-native-decor="true"]');
      var form = document.getElementById('product_form_' + productId);
      var source = nativeRoot && nativeRoot.querySelector('#ss-werx-summary');
      var sourceTotal = source && source.querySelector('[data-werx-total]');
      var sourceSelection = source && source.querySelector('[data-werx-selection]');
      var action = panel.querySelector('[data-ss-mobile-review-action]');
      var total = panel.querySelector('[data-ss-mobile-total]');
      var selection = panel.querySelector('[data-ss-mobile-selection]');
      if (!nativeRoot || !form || !nativeRoot.contains(form) || !sourceTotal || !sourceSelection || !action || !total || !selection) return;
      panel.dataset.ssMobileReady = 'true';
      function mirror() {
        var text = sourceTotal.textContent.trim();
        panel.hidden = source.hidden || !text;
        if (total.textContent !== text) total.textContent = text;
        var details = sourceSelection.textContent.trim();
        if (selection.textContent !== details) selection.textContent = details;
      }
      var observer = new MutationObserver(mirror);
      observer.observe(source, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['hidden']});
      action.addEventListener('click', function () {
        var invalid = Array.from(form.elements).find(function (field) {
          return field.willValidate && !field.disabled && !field.validity.valid && field.getClientRects().length;
        });
        var target = invalid || form.querySelector('button.addtocart-js');
        if (!target) return;
        var motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        (invalid || source).scrollIntoView({behavior:motion, block:'center'});
        target.focus({preventScroll:true});
      });
      window.addEventListener('pagehide', function () { observer.disconnect(); }, {once:true});
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) { observer.observe(source, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['hidden']}); mirror(); }
      });
      mirror();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, {once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
